import React from "react";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// POC 2 only — registers five placeholder routes under
// `/platform/accountSettings/admission/...`, one for each admission item in
// the new unified-portal Admission section. Each renders only the localised
// page title (no real screen plumbing; the existing per-unit admission
// screens depend on a unitId context that is intentionally absent here).
const POC2_ADMISSION_ITEMS = [
  { path: "units-and-schools", labelLocale: "admissions:units_and_schools" },
  { path: "enrolment-cycles", labelLocale: "admissions:admission_cycles" },
  { path: "stages-and-statuses", labelLocale: "admissions:stages_and_statuses" },
  { path: "checklists", labelLocale: "admissions:checklists" },
  {
    path: "form-and-field-settings",
    labelLocale: "admissions:form_and_field_settings",
  },
];

const makeChildRoute = ({ path, labelLocale }) => ({
  path,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admission-poc-placeholder" */ "./components"
    ).then(({ default: AdmissionPocPlaceholder }) => {
      const Wrapper = () => <AdmissionPocPlaceholder labelLocale={labelLocale} />;
      Wrapper.displayName = `AdmissionPocPlaceholderRoute(${path})`;
      return Wrapper;
    })
  ),
});

export default () => ({
  path: "admission",
  // Pathless wrapper — children mount directly at /admission/<path>.
  childRoutes: POC2_ADMISSION_ITEMS.map(makeChildRoute),
});
